import {
  MAX_NAME_LENGTH,
  MAX_EMAIL_LENGTH,
  MAX_PHONE_LENGTH,
  MAX_ADDRESS_LENGTH,
  MAX_CITY_LENGTH,
  MAX_REGION_LENGTH,
  MAX_ZIP_CODE_LENGTH,
  MAX_WEBSITE_LENGTH,
} from '@/shared/config';
import { InferType, object, string } from '@/shared/config/yup';

export const editCompanyInfoFormSchema = object({
  companyName: string().required().max(MAX_NAME_LENGTH),
  printName: string().max(MAX_NAME_LENGTH),
  workEmail: string().email().max(MAX_EMAIL_LENGTH),
  phoneNumber: string().max(MAX_PHONE_LENGTH),
  stateRegion: string().max(MAX_REGION_LENGTH),
  city: string().max(MAX_CITY_LENGTH),
  zipCode: string().max(MAX_ZIP_CODE_LENGTH),
  address: string().max(MAX_ADDRESS_LENGTH),
  webSite: string().max(MAX_WEBSITE_LENGTH),
  country: string(),
});

export type EditCompanyInfoFormPayload = InferType<
  typeof editCompanyInfoFormSchema
>;
